import { useState } from "react";

function VideoShowcase({ content }) {
  const [isPlaying, setIsPlaying] = useState(true);

  return (
    <section className="video-showcase" aria-label={content.title} data-wow="zoom">
      <img
        className="video-poster"
        src={content.poster}
        alt={content.posterAlt}
      />
      <div className="video-shade" />

      <div className="container video-controls">
        <button
          className="video-toggle"
          type="button"
          aria-label={isPlaying ? "Pause showcase" : "Play showcase"}
          onClick={() => setIsPlaying((currentState) => !currentState)}
        >
          <i className={`fa-solid ${isPlaying ? "fa-pause" : "fa-play"}`} />
        </button>
        <div className="video-progress" aria-hidden="true">
          <span className={isPlaying ? "is-playing" : ""} />
        </div>
      </div>
    </section>
  );
}

export default VideoShowcase;
